import { Link } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const NoLedgerAccountsCallout = () => {
  const { navigation } = useNavigation()

  return (
    <Callout
      description={i18n.t(
        'finance.settings.accounting.custom_categories.modals.callouts.no_ledger_accounts.description'
      )}
      type="info"
      link={
        <Link.Router to={navigation.finance.accounting.fullPath()} type="solid">
          {i18n.t(
            'finance.settings.accounting.custom_categories.modals.callouts.no_ledger_accounts.action'
          )}
        </Link.Router>
      }
    />
  )
}

export default NoLedgerAccountsCallout
